import React from 'react';
import PageLayout from '../../components/common/page-layout';
import Grid from '@mui/material/Grid';
import ActionCard from '../../components/common/action-card';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import ListAltIcon from '@mui/icons-material/ListAlt';
import InventoryTable from '../../components/inventory/inventory-table';
import { Typography } from '@mui/material';

export default function Inventory() {
  return (
    <PageLayout pageTitle="انبارداری">
      <Grid container spacing={3} sx={{ mb: 10 }} justifyContent="center">
        <Grid item xs={12} md={6} lg={3}>
          <ActionCard
            name="افزودن موجودی"
            icon={<SystemUpdateAltIcon />}
            path="/inventory/insert"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <ActionCard name="مدل‌ها و برند‌ها" icon={<ListAltIcon />} path="/inventory/models" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <ActionCard name="تحویل سفارش" icon={<ListAltIcon />} path="/inventory/delivery" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}></Grid>
        <Grid item xs={12} md={8}>
          <Typography variant="h6" lineHeight={3}>
            موجودی انبار
          </Typography>
          <InventoryTable />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
